<template>
  <authorization permissionKey="island_pre_exam_queue" can="read">
    <Attendances
      v-if="attendancePlace"
      queueType="pre_exam"
      :attendancePlaceId="attendancePlace.id"
      :pollInterval=60000
    />
  </authorization>
</template>

<script>
  import Attendances from "@/components/queues/attendances.vue";

  export default {
    name: "PreExam",
    components: {
      Attendances,
    },
    props: {
      attendancePlace: Object,
    },
  };
</script>

<style lang="scss" scoped></style>
